
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airmiles",
      function () {
        return require("private-next-pages/airmiles.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/airmiles"])
      });
    }
  